import { Space, Typography, Select } from "antd";
import { DatePicker } from "../../../components/antOverrides";
import moment from "moment";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { setDate } from "../dayCenterPatientSlice";
import { getFullName } from "../../../components/util/helpers";
import { useEffect } from "react";
const { Title } = Typography;
const { Option } = Select;

const Header = (props) => {
  const {
    record,
    effectiveOrders,
    onOrderChange,
    selectedOrder,
    filteredData,
  } = props;
  const intl = useIntl();
  const activeDate = useSelector((state) => state.dayCenterPatient.activeDate);
  const dispatch = useDispatch();

  // Select the first order on component mount or when orders change
  useEffect(() => {
    if (effectiveOrders?.length > 0 && !selectedOrder) {
      onOrderChange(effectiveOrders[0].id);
    }
  }, [effectiveOrders, selectedOrder, onOrderChange]);

  const onDateChange = (val) => {
    dispatch(setDate({ date: moment(val).toISOString() }));
  };

  const patientName = getFullName(
    record?.patient?.surename,
    record?.patient?.first_name
  );

  // Determine if the select should be disabled (when there's only one order)
  const isSelectDisabled = effectiveOrders?.length === 1;

  const approvedDaysCount =
    filteredData?.filter((item) => item.approved).length || 0;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
      }}
    >
      <div>
        <Title level={1} style={{ marginTop: "0px", marginBottom: "0px" }}>
          {patientName}
        </Title>
        <Space
          size="middle"
          direction="horizontal"
          style={{ marginTop: "8px" }}
        >
          <DatePicker
            value={activeDate && moment(activeDate)}
            onChange={onDateChange}
            picker="month"
            format={"MM/YYYY"}
            placeholder={intl.formatMessage({
              id: `app.gaps.select_month`,
            })}
            allowClear={false}
          />
          <Select
            style={{ width: 200 }}
            placeholder={intl.formatMessage({
              id: "app.prospectuses.chooseClient",
            })}
            onChange={onOrderChange}
            disabled={isSelectDisabled}
            value={selectedOrder}
          >
            {effectiveOrders?.map((order) => (
              <Option key={order.id} value={order.id}>
                {order?.client?.name}
              </Option>
            ))}
          </Select>
          <div>
            <Title
              level={4}
              style={{
                marginTop: "0px",
                marginBottom: "0px",
                textAlign: "right",
                fontWeight: "normal",
              }}
            >
              {intl.formatMessage({ id: "app.patients.approved_days" })}:{" "}
              <b>{approvedDaysCount}</b>
            </Title>
          </div>
        </Space>
      </div>
    </div>
  );
};

export default Header;
